<template>
  <div class="cpsqd">
    <div class="cps-content">
      <div class="module-1">
        <p class="title">青岛港（舱单）发送</p>
        <p class="text">一键引入场站数据，操作简单周末及节假日均可发送</p>
        <span class="btn" @click="openQQ">开通咨询</span>
      </div>
      <div class="module" :class="`module-${item.index}`" v-for="(item, i) in module" :key="i">
        <div class="content">
          <p class="title">{{ item.title }}</p>
          <span class="text" v-html="item.content" />
        </div>
      </div>
      <div class="module-explain">
        <div class="nav">如何发送舱单？</div>
        <div class="explain-box">
          <div :class="`explain-box-${item.type}`" v-for="(item, i) in explain" :key="i">
            <img class="number-icon" :src="item.numUrl" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text" v-html="item.text" />
          </div>
        </div>
      </div>
      <ContactUs />
    </div>
  </div>
</template>
<script>
import ContactUs from '@/components/ContactUs'
import { ossUrl } from '@/utils/config.js'
import { openQQ } from '@/utils/common.js'
export default {
  name: 'cps',
  components: { ContactUs },
  data() {
    return {
      module: [
        {
          index: 2,
          title: '一键引入场站信息',
          content: '发送更安心，一键引入场站数据<br />方便快捷，支持26家场站'
        },
        {
          index: 3,
          title: '不限船司 不限船代',
          content: '支持12家船代的舱单发送～'
        },
        {
          index: 4,
          title: '高效录单 快速回执',
          content: '支持多种录单模式，「在线录单」、「Excel模版导入」、以及「OpenAPI」对接，助力企业降本增效；'
        }
      ],
      explain: [
        {
          type: 'left',
          numUrl: `${ossUrl}/common/introduce/number-1.png`,
          title: '开通舱单权限',
          text: '注册账号并完成企业认证， <br /> 可联系您的专属销售快速开通服务；'
        },
        {
          type: 'center',
          numUrl: `${ossUrl}/common/introduce/number-2.png`,
          title: '录入舱单信息',
          text: '您可以选择「在线录入」或「Excel模版导入」录入舱单信息'
        },
        {
          type: 'right',
          numUrl: `${ossUrl}/common/introduce/number-3.png`,
          title: '手机端查看回执',
          text: '平均5分钟可接收回执'
        }
      ]
    }
  },
  methods: {
    openQQ
  }
}
</script>
<style lang="scss" scoped>
.cpsqd {
  width: 100vw;
  overflow-x: hidden;

  .cps-content {
    width: 100%;
    min-width: 1920px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .module-1 {
    height: 1080px;
    margin: -60px auto 0;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cpsqd-module-1.png');
    background-size: 100%;
    background-repeat: no-repeat;
    text-align: center;

    .title {
      font-size: 68px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212450;
      line-height: 95px;
      letter-spacing: 1px;
      padding-top: 118px;
    }

    .text {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212450;
      line-height: 35px;
      letter-spacing: 3px;
      padding-top: 16px;
    }

    .btn {
      width: 180px;
      height: 64px;
      display: block;
      background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/btn.png');
      background-size: 100%;
      margin: 24px auto 0;
      line-height: 64px;
      font-weight: 600;
      color: #ffffff;
      font-size: 24px;
      cursor: pointer;
    }
  }

  .module {
    margin: 120px auto 0;
    background-repeat: no-repeat;

    .content {
      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212450;
        line-height: 45px;
        letter-spacing: 1px;
      }

      .text {
        display: inline-block;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding-top: 24px;
        text-align: justify;
      }
    }
  }

  .module-2 {
    height: 643px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cpsqd-module-2.png');
    background-size: 1411px 643px;
    background-position: 322px;

    .content {
      padding: 250px 0 0 370px;

      .text {
        display: inline-block;
        width: 322px;
        letter-spacing: 1px;
      }
    }
  }

  .module-3 {
    height: 649px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cpsqd-module-3.png');
    background-size: 1416px 750px;
    background-position: 239px;

    .content {
      float: right;
      padding: 220px 356px 0 0;

      .text {
        display: inline-block;
        width: 310px;
        letter-spacing: 1px;
      }
    }
  }

  .module-4 {
    height: 648px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/cpsqd-module-4.png');
    background-size: 1444px 648px;
    background-position: 289px;

    .content {
      padding: 249px 0 0 360px;

      .text {
        width: 328px;
        font-size: 22px;
        letter-spacing: 1px;
      }
    }
  }

  .module-explain {
    width: 1180px;
    margin: 119px auto 0;

    .nav {
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      letter-spacing: 2px;
    }

    .explain-box {
      width: 100%;
      margin-top: 48px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap-reverse;

      & > div {
        width: 380px;
        box-sizing: border-box;
        padding: 48px 0 0 48px;
        color: white;

        .number-icon {
          width: 49px;
          height: 49px;
        }

        .title {
          font-size: 24px;
          padding-top: 16px;
        }

        .text {
          padding-top: 9px;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 1px;
        }
      }

      .explain-box-left {
        height: 252px;
        background: #3371ff;
        border-radius: 8px 0 0 8px;
      }

      .explain-box-center {
        padding-top: 92px;
        height: 296px;
        background: #ffb817;
        border-radius: 8px 8px 0 0;
      }

      .explain-box-right {
        height: 252px;
        background: #1170eb;
        border-radius: 0 8px 8px 0;
      }
    }
  }
}
</style>
